var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadMobile = function SvgDownloadMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 5,
    width: 40,
    height: 78,
    rx: 3.75,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.264 29h7.015v11.56h-4.35V32.72h-3.895L39.264 29Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 58.045a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-3.632a4.368 4.368 0 1 0 0-8.736 4.368 4.368 0 0 0 0 8.736Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80h20v-2H34v2Z",
    fill: "currentColor"
  })));
};
export { SvgDownloadMobile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHZpZXdCb3g9IjAgMCA4OCA4OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMjQiIHk9IjUiIHdpZHRoPSI0MCIgaGVpZ2h0PSI3OCIgcng9IjMuNzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTM5LjI2NDMgMjlINDYuMjc5MVY0MC41NTk2SDQxLjkyOTlWMzIuNzIxMkgzOC4wMzM3TDM5LjI2NDMgMjlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NCA1OC4wNDUxQzQ4LjQxODMgNTguMDQ1MSA1MiA1NC40NjM0IDUyIDUwLjA0NTFDNTIgNDUuNjI2OCA0OC40MTgzIDQyLjA0NTEgNDQgNDIuMDQ1MUMzOS41ODE4IDQyLjA0NTEgMzYgNDUuNjI2OCAzNiA1MC4wNDUxQzM2IDU0LjQ2MzQgMzkuNTgxOCA1OC4wNDUxIDQ0IDU4LjA0NTFaTTQ0IDU0LjQxMzJDNDYuNDEyNCA1NC40MTMyIDQ4LjM2ODEgNTIuNDU3NSA0OC4zNjgxIDUwLjA0NTFDNDguMzY4MSA0Ny42MzI3IDQ2LjQxMjQgNDUuNjc3IDQ0IDQ1LjY3N0M0MS41ODc2IDQ1LjY3NyAzOS42MzE5IDQ3LjYzMjcgMzkuNjMxOSA1MC4wNDUxQzM5LjYzMTkgNTIuNDU3NSA0MS41ODc2IDU0LjQxMzIgNDQgNTQuNDEzMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMzQgODBINTRWNzhIMzRWODBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";